/*!
 * AudoChat - App Theme Component
 */

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { useMemo } from "react";
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

function AppTheme({ direction, children }) {
  const rtlCache = useMemo(() => {
    if (direction === "rtl") {
      return createCache({
        key: "rtl",
        stylisPlugins: [rtlPlugin],
      });
    }
    return null;
  }, [direction]);

  if (direction === "rtl") {
    return (
      <CacheProvider value={rtlCache}>
        <ThemeProvider theme={themeRTL}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </CacheProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default AppTheme;

